import { makeVar } from '@apollo/client'

export const NextResourceSearchTerms = makeVar<string>('')
export const ResourceSearchTerms = makeVar<string>('')
export const SearchTagNodeId = makeVar<string | null>(null)
export const SearchTagNodeIdSkipped = makeVar<boolean>(false)
export const SearchTagsFilter = makeVar<string[]>([])
